import styled from 'styled-components';

import { Button } from '@/shared/components/button';

export const ShareButton = styled(Button)`
  height: 54px;
  line-height: 21.6px;
  font-size: 18px;
  font-weight: 600;
  width: 100%;
  margin-top: 15px;
`;
